import { render, staticRenderFns } from "./providerShippingInfo.vue?vue&type=template&id=40afa496&scoped=true&"
import script from "./providerShippingInfo.vue?vue&type=script&lang=js&"
export * from "./providerShippingInfo.vue?vue&type=script&lang=js&"
import style0 from "./providerShippingInfo.vue?vue&type=style&index=0&id=40afa496&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40afa496",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VForm,VRow})
